import React, { useEffect, useCallback } from 'react';
import { observer } from 'mobx-react';
import './index.scss';

const Color = ['#000000', '#A9A9A9', '#CD5C5C', '#FFFACD', '#20B2AA', '#FF6347', '#6A5ACD', '#FFFFFF', '#008000'];

interface Props{
  id: string;
  attrs: any;
  onClick: (color: string) => void;
}
function ColorSelect({ onClick, attrs, id }: Props) {
  const { color } = attrs;
  useEffect(() => {
    document.addEventListener('click', (e: any) => {
      if (id) {
        const ref = document.getElementById(id);
        const parent = ref?.parentNode;
        try {
          if (parent && !parent.contains(e.target)) {
            (ref as HTMLElement).style.display = 'none';
          }
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(err);
        }
      }
    });
  }, []);
  const setStyle = useCallback((col) => {
    if (id === 'syl-diy-background-container') {
      return { background: col, color: col === '#FFFFFF' ? '#000000' : '#FFFFFF' };
    }
    return { color: col, background: col === '#FFFFFF' ? '#000000' : '#FFFFFF' };
  }, []);

  return (
    <div className="color-container" id={id}>
      {Color.map((col) => (
        <div
          key={col}
          className={`color-item ${color === col && 'active'}`}
          style={setStyle(col)}
          onClick={(e) => {
            e.stopPropagation();
            onClick(col);
          }}
        >
          A
        </div>
      ))}
    </div>
  );
}

export default React.memo(observer(ColorSelect));
